// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TProcessActionButtonsRequest,
  TProcessActionButtonsModel,
  IMappers,
  TProcessActionButtonsResponse,
  TProcessActionButtonsResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createProcessActionButtonsModel(parameters: TProcessActionButtonsRequest): TProcessActionButtonsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cian-chat-bot',
    pathApi: '/v2/process-action-buttons/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IProcessActionButtonsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TProcessActionButtonsRequest;
}

export async function fetchProcessActionButtons<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IProcessActionButtonsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TProcessActionButtonsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createProcessActionButtonsModel(parameters),
    config,
  )) as FetchResponse<TProcessActionButtonsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TProcessActionButtonsResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TProcessActionButtonsResponse>;
}
